import * as React from 'react'

import Api from './services/api'

/** https://medium.com/@jrwebdev/react-higher-order-component-patterns-in-typescript-42278f7590fb */
export interface IInjectedServiceProps {
  api: Api
}

const api = new Api()

const withServices = <P extends IInjectedServiceProps>(
  Component: React.ComponentType<P>
) => {
  const WithServices: React.SFC<P> = props => <Component api={api} {...props} />

  WithServices.displayName = `WithServices(${Component.displayName ||
    Component.name})`

  return WithServices
}

export default withServices



// WEBPACK FOOTER //
// ./src/withServices.tsx